/**
 * Enpass Password Manager
 *
 * Exposes a single fixed list of twelve web-accessible resources — the inline dialog
 * and menu HTML plus its icon set — to http(s) origins with no use_dynamic_url. Every
 * one is reachable from any page at a stable URL.
 *
 * The icons are the cleanest signal: they load through probeImage with no CORS grant,
 * and the vendor-named enpass_blue.svg is distinctive to this extension.
 *
 * Manifest verified against version 6.11.14.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'kmcfomidfpdkfieipokbalgegidffkal';

export const enpass: ExtensionDefinition = {
  id: ID,
  name: 'Enpass Password Manager',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'Twelve static WAR on http(s) origins, including the vendor-named enpass_blue.svg ' +
    'and the injected dialog HTML. Detection is a single load and conclusive.',
  signals: [
    {
      id: 'war-icon-16',
      kind: 'web-accessible-resource',
      description:
        'Load icons/icon-16.png via <img> — exposed to http(s) origins and readable ' +
        'without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'icons/icon-16.png'),
    },
    {
      id: 'war-enpass-blue-svg',
      kind: 'web-accessible-resource',
      description:
        'Load icons/enpass_blue.svg via <img> — a vendor-named icon, distinctive to Enpass.',
      weight: 0.5,
      run: () => probeImage(ID, 'icons/enpass_blue.svg'),
    },
    {
      id: 'war-dialog-html',
      kind: 'web-accessible-resource',
      description: 'Fetch injected/dialog/dialog.html — the injected autofill dialog, a third path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'injected/dialog/dialog.html'),
    },
  ],
};
